import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { catchError, from, Observable, switchMap, throwError } from 'rxjs';
import { AuthService } from 'src/app/services/auth/auth.service';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';

@Injectable()
export class AuthenticationInterceptor implements HttpInterceptor {
  constructor(
    private readonly message: MessageService,
    private readonly authService: AuthService,
    private readonly router: Router
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status !== 401 || request.url.includes('/identity/session')) {
          return throwError(() => error);
        }

        // Access token scaduto: se la sessione si può rinnovare si rifà la richiesta una volta sola
        // con il token nuovo, senza che l'utente se ne accorga.
        const authorization = request.headers.get('Authorization');
        if (authorization && this.authService.canRefresh()) {
          const staleToken = authorization.replace(/^Bearer /, '');
          return from(this.authService.refreshSession(staleToken)).pipe(
            switchMap(outcome => {
              if (outcome === 'ok') {
                return next
                  .handle(
                    request.clone({
                      setHeaders: { Authorization: `Bearer ${this.authService.getToken()}` },
                    })
                  )
                  .pipe(
                    catchError((retryError: HttpErrorResponse) =>
                      retryError.status === 401
                        ? this.sessionExpired(retryError)
                        : throwError(() => retryError)
                    )
                  );
              }
              // Problema temporaneo (rete/server) nel rinnovo: la sessione resta, la richiesta fallisce
              if (outcome === 'error') return throwError(() => error);
              return this.sessionExpired(error);
            })
          );
        }

        return this.sessionExpired(error);
      })
    );
  }

  private sessionExpired(error: HttpErrorResponse) {
    this.message.add({
      id: 1000,
      severity: 'error',
      summary: 'Sessione scaduta',
      detail: "La tua sessione è scaduta, rieffettuare l'accesso.",
      life: 2000,
    });
    this.authService.logout();
    this.router.navigateByUrl('/login');
    return throwError(() => error);
  }
}
